module.exports = __webpack_public_path__ + "img/img-5.d6bf4e52.webp";